import { formatInTimeZone } from 'date-fns-tz';

export const utcToZonedTime = (date: Date | string | number, timeZone: string): Date => {
    let d = date;

    if (typeof d === 'string' || typeof d === 'number') {
        d = new Date(date);
    }
    const formattedDate = formatInTimeZone(d, timeZone, 'yyyy-MM-dd HH:mm:ss');

    return new Date(formattedDate);
};
